var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subcategory-filters",attrs:{"id":"subcategory-filter-toggle"}},[_c('i',{staticClass:"subcategory-filters__filters-icon icon-filters",attrs:{"id":"subcategory-filter-toggle-icon"},on:{"click":_vm.openFilters}})])}
var staticRenderFns = []

export { render, staticRenderFns }